import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { isMembershipActive } from '../lib/supabase';
import '../styles/Join.css';

interface Props {
  appUserId: string | null;
  onActivated: () => void;
}

// Shown after Stripe payment. Waits for the membership to switch on.
function WelcomePage({ appUserId, onActivated }: Props) {
  const [timedOut, setTimedOut] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!appUserId) return;
    let tries = 0;
    const timer = setInterval(async () => {
      tries += 1;
      if (await isMembershipActive(appUserId)) {
        clearInterval(timer);
        onActivated();
        navigate('/', { replace: true });
      } else if (tries >= 20) {
        clearInterval(timer);
        setTimedOut(true);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [appUserId, onActivated, navigate]);

  return (
    <div className="join-page">
      <div className="join-card">
        <h1>Welcome aboard</h1>
        {!timedOut ? (
          <>
            <div className="spinner"></div>
            <p>Confirming your membership...</p>
          </>
        ) : (
          <p>
            Payment received, but activation is taking longer than usual.
            Refresh in a minute, or email tonygouv@hotmail.com if it
            still isn't showing.
          </p>
        )}
      </div>
    </div>
  );
}

export default WelcomePage;
